// WeKIT Education Intelligence™ — KPI Glossary
// Central source of truth for KPI names, one-line definitions, and formulas.

export interface GlossaryEntry {
  key: string;
  name: string;
  short: string;
  definition: string;
  formula?: string;
  scale?: string;
}

export const glossary: GlossaryEntry[] = [
  {
    key: "hdi",
    name: "Human Development Index™",
    short: "Holistic growth score across cognitive, emotional, and character dimensions.",
    definition:
      "A composite measure of a learner's development across Cognitive Load, Emotional Intelligence, Grit, Purpose, and Character. Recalibrated every 30 days from multi-source signals.",
    formula: "HDI = (0.4·Cognitive_Load) + (0.35·Emotional_Intelligence) + (0.25·Grit_Metric) / normalization_factor",
    scale: "0–100 (or 0.0–10.0 at student scale)",
  },
  {
    key: "cci",
    name: "Career Clarity Index™",
    short: "How clearly a learner can articulate a purpose-aligned career path.",
    definition:
      "Signals from career explorations, reflections, top-cluster consistency, and mentor conversations. Rising CCI predicts decisive stream and college choices.",
    scale: "0–100%",
  },
  {
    key: "fri",
    name: "Future Readiness Index™",
    short: "Readiness for the AI-driven workplace.",
    definition:
      "Weighted score across AI fluency, creativity, communication, collaboration, and adaptability — benchmarked against peer international schools.",
    scale: "0–100",
  },
  {
    key: "portfolio",
    name: "Portfolio artifacts",
    short: "Count of verified learning evidence in the student's Digital Portfolio.",
    definition:
      "Projects, certifications, reflections, and mentor endorsements — each with provenance and evidence links.",
  },
  {
    key: "completion",
    name: "Assessment completion",
    short: "% of enrolled learners who completed WCC360 this cycle.",
    definition:
      "Measured across all active grades; excludes learners onboarded within the last 14 days.",
    scale: "0–100%",
  },
  {
    key: "active",
    name: "Active students",
    short: "Learners with meaningful platform activity in the last 30 days.",
    definition:
      "Activity = assessment, reflection, module progress, mentor session, or portfolio contribution.",
  },
];

export const byKey = Object.fromEntries(glossary.map((g) => [g.key, g])) as Record<string, GlossaryEntry>;
